import React from "react";
import { Box } from "@mui/material";
import CommonButton from "../../../CommonComponents/CommonButton";
import CommonInput from "../../../CommonComponents/CommonInput";
import CommonSelect from "../../../CommonComponents/Select/CommonSelect";
import FieldError from "./FieldError";
import styles from "../AddVendorModal.module.css";
import {
  locationInputSx,
  locationSelectSx,
  removeLocationBtnSx,
  buildSelectStylesBundle,
} from "../AddVendorModal.styles";
import { getLocationErrorKey } from "../../../Utils/addVendorModal.utils";

const locationSelectStyles = buildSelectStylesBundle({
  selectStyleObj: locationSelectSx,
});

const ServiceLocationRow = ({
  index,
  location,
  stateOptions,
  cityOptions,
  subProductOptions,
  showAdvanced,
  locationErrors,
  onFieldChange,
  onRemove,
}) => (
  <Box className={styles.locationRow}>
    <Box className={styles.locationRowTop}>
      <CommonSelect
        showLabel={false}
        value={location.state}
        options={stateOptions}
        placeholder="Select State"
        onChange={(e) => onFieldChange(index, "state", e.target.value)}
        error={locationErrors[getLocationErrorKey(index, "state")]}
        inputProps={{ "aria-label": "State" }}
        styles={locationSelectStyles}
      />

      <CommonSelect
        showLabel={false}
        value={location.city}
        options={cityOptions}
        placeholder="Select City"
        disabled={!location.state}
        onChange={(e) => onFieldChange(index, "city", e.target.value)}
        error={locationErrors[getLocationErrorKey(index, "city")]}
        inputProps={{ "aria-label": "City" }}
        styles={locationSelectStyles}
      />
    </Box>

    {showAdvanced && (
      <Box className={styles.locationRowBottom}>
        <CommonSelect
          isMulti
          showLabel={false}
          value={location.sub_products || []}
          options={subProductOptions}
          placeholder="Select Sub Product ID"
          onChange={(e) => {
            const raw = e.target.value;

            onFieldChange(
              index,
              "sub_products",
              typeof raw === "string" ? raw.split(",") : raw
            );
          }}
          error={locationErrors[getLocationErrorKey(index, "sub_products")]}
          inputProps={{ "aria-label": "Sub Products" }}
          styles={locationSelectStyles}
        />

        <Box className={styles.fieldWrapper}>
          <CommonInput
            label=""
            name="per_week_capacity"
            value={location.per_week_capacity || ""}
            placeholder="Capacity"
            onChange={(e) =>
              onFieldChange(index, "per_week_capacity", e.target.value)
            }
            removeBackGround
            sx={locationInputSx}
          />

          <FieldError
            error={
              locationErrors[getLocationErrorKey(index, "per_week_capacity")]
            }
          />
        </Box>
      </Box>
    )}

    {index > 0 && (
      <Box className={styles.locationRowActions}>
        <CommonButton
          label="Remove"
          onClick={() => onRemove(index)}
          fitContent
          sx={removeLocationBtnSx}
        />
      </Box>
    )}
  </Box>
);

export default ServiceLocationRow;
